import { HistoryDeposit } from '../../Entities/History.Deposit.Entity';
import { BaseApi } from '../index.exports';

export class HistoryDepositFrontEndApiCalls extends BaseApi {
    protected static _Entity = HistoryDeposit;

    // #region api

    // #endregion api
}
